import {
    ICadastrarVisita,
    ICompromissoRequest,
} from "../../../Interfaces/Vendas/Compromisso/CompromissoInterface";
import {
    CadastrarVisitaVendasService,
    CompromissoVendasService,
    DeletarVisitaVendasService,
    ListarPontosVendaService,
    ListarPorLeadVendasService,
} from "../../../Services/Vendas/Compromisso/CompromissoService";
import { Controller } from "../../Controller";

export async function CompromissoVendasController(
    requestBody: ICompromissoRequest
) {
    return Controller(CompromissoVendasService(requestBody));
}

export async function ListarPontosVendaController() {
    return Controller(ListarPontosVendaService());
}

export async function ListarEtapasVendasController(
    idLead: number,
    dtCompromissos: string
) {
    return Controller(ListarPorLeadVendasService(idLead, dtCompromissos));
}

export async function CadastrarVisitaVendasController(
    requestBody: ICadastrarVisita
) {
    return Controller(CadastrarVisitaVendasService(requestBody));
}

export async function DeletarVisitaVendasController(ID_CASO_VISITA: number) {
    return Controller(DeletarVisitaVendasService(ID_CASO_VISITA));
}
